import { ChevronRight, Clock } from "lucide-react";

export default function EntityTimeline({ items, emptyText = "No events yet" }) {
  if (!items || !items.length) {
    return <div className="text-hocp-textMuted text-sm py-6 text-center">{emptyText}</div>;
  }
  return (
    <div className="space-y-3" data-testid="entity-timeline">
      {items.map((t, i) => (
        <div key={i} className="flex gap-3 border-l-2 border-hocp-border pl-4 py-1.5">
          <Clock className="w-3 h-3 text-hocp-textTertiary mt-1 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <div className="text-[11px] mono text-hocp-textMuted">{(t.at || "").replace("T", " ").slice(0, 19)}</div>
            <div className="text-[13px] text-hocp-textPrimary flex items-center gap-1 flex-wrap">
              <span className="mono text-amber-300">{t.event}</span>
              {t.note && <><ChevronRight className="w-3 h-3 text-hocp-textTertiary" /><span className="text-hocp-textPrimary">{t.note}</span></>}
            </div>
            {t.by && <div className="text-[11px] text-hocp-textMuted">by {t.by}</div>}
          </div>
        </div>
      ))}
    </div>
  );
}
